<ng-container *ngIf="isAuthChecked">
	<router-outlet></router-outlet>
</ng-container>

<div *ngIf="!isAuthChecked" class="p-4 text-center text-lg">
	{{ translateServ.dictionary['LOADING'] }}
</div>

<div *ngIf="!cookieConsentService.decisionMade()" class="cookie-banner">
	<span>{{ translateServ.dictionary['COOKIE_STATMENT'] }}</span>
	<button type="button" (click)="cookieConsentService.accept()">{{ translateServ.dictionary['COOKIE_OK_BTN'] }}</button>
</div>

<app-session-timeout-dialog />